module.exports = __webpack_public_path__ + "static/media/400ruwang.4a513ae1.jpg";